export default __webpack_public_path__ + "static/media/furnisihing.27b7857a.jpg";